import I18n from 'I18n';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import HubSpotAppLink from 'crm-links/common/components/HubSpotAppLink';
import { allPropertiesHistory } from '../../helpers/crmLinks';
import { HIGHLIGHT_CARD_ACTION_ALL_PROPERTIES, HIGHLIGHT_CARD_ACTION_PROPERTIES_HISTORY, HIGHLIGHT_CARD_ACTIONS_LIST, PROFILE_SETTINGS_ACTIONS_BTN } from '../../constants/dataTestIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HighlightActions = ({
  objectId,
  objectTypeId
}) => /*#__PURE__*/_jsx(UIDropdown, {
  menuWidth: 204,
  placement: "bottom right",
  buttonText: I18n.text('highlightCard.buttons.actions'),
  "data-test-id": PROFILE_SETTINGS_ACTIONS_BTN,
  buttonUse: "transparent",
  children: /*#__PURE__*/_jsxs(UIList, {
    "data-test-id": HIGHLIGHT_CARD_ACTIONS_LIST,
    children: [/*#__PURE__*/_jsx(HubSpotAppLink, {
      linkType: "CRM_OBJECT_RECORD_ALL_PROPERTIES",
      linkTypeProps: {
        includeEschref: true,
        objectTypeId,
        objectId
      },
      LinkComponentProps: {
        'data-test-id': HIGHLIGHT_CARD_ACTION_ALL_PROPERTIES
      },
      children: I18n.text('highlightCard.buttons.allProperties')
    }), /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": HIGHLIGHT_CARD_ACTION_PROPERTIES_HISTORY,
      href: allPropertiesHistory({
        objectTypeId,
        objectId
      }),
      children: I18n.text('highlightCard.buttons.propertiesHistory')
    })]
  })
});
export default HighlightActions;